import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseFormLayout } from './BaseFormLayout';
import { CompanyType, ProfileType } from '../../../types/profile';
import { RadioButton } from '../../common/RadioButton';
import { ROLES } from '../../../types/auth';

interface CompanyTypeFormProps {
  firstName: string;
  profileType: ProfileType;
  onCompanyTypeSelect: (type: CompanyType) => void;
  onProfileTypeChange: (type: ProfileType) => void;
  onBack?: () => void;
  onSubmit: (e: React.FormEvent) => void;
  isSubmitting: boolean;
}

export const CompanyTypeForm: React.FC<CompanyTypeFormProps> = ({
  firstName,
  profileType,
  onCompanyTypeSelect,
  onProfileTypeChange,
  onBack,
  onSubmit,
  isSubmitting,
}) => {
  const { t } = useTranslation('auth');

  const renderProfileTypeSelector = () => {
    return (
      <div className="flex my-4 space-x-8">
        <RadioButton
          checked={profileType === 'freelancer'}
          onChange={() => onProfileTypeChange(ROLES.FREELANCER)}
          label={t('profileTypeStep.freelancer')}
          name="profileType"
          value={ROLES.FREELANCER}
        />
        <RadioButton
          checked={profileType === 'recruiter'}
          onChange={() => onProfileTypeChange(ROLES.RECRUITER)}
          label={t('profileTypeStep.recruiter')}
          name="profileType"
          value={ROLES.RECRUITER}
        />
      </div>
    );
  };

  return (
    <BaseFormLayout
      firstName={firstName}
      onBack={onBack}
      withFormActions={false}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
    >
      <div className="w-full max-w-md">
        <div className="font-ambit text-[1.5625rem] not-italic font-[900] leading-[1.875rem] text-secondary">
          {t('profileTypeStep.inscription')}
        </div>

        <div className="font-ambit text-[1.0625rem] not-italic font-normal leading-[1.5625rem] text-[#3B5266]">
          {t('profileTypeStep.as')}
        </div>

        {renderProfileTypeSelector()}

        <button
          type="button"
          className="w-full bg-primary text-white py-2 px-4 rounded-full font-ambit text-[1.0625rem] not-italic font-[900] leading-[1.5625rem] mt-4"
          onClick={() => onCompanyTypeSelect('individual')}
        >
          {t('common:companyType.individual')}
        </button>
        <button
          type="button"
          className="w-full bg-primary text-white py-2 px-4 rounded-full font-ambit text-[1.0625rem] not-italic font-[900] leading-[1.5625rem] mt-4"
          onClick={() => onCompanyTypeSelect('company')}
        >
          {t('common:companyType.company')}
        </button>
        <button
          type="button"
          className="w-full bg-primary text-white py-2 px-4 rounded-full font-ambit text-[1.0625rem] not-italic font-[900] leading-[1.5625rem] mt-4"
          onClick={() => onCompanyTypeSelect('organization')}
        >
          {t('common:companyType.organization')}
        </button>
      </div>
    </BaseFormLayout>
  );
};
